/**
 * The selection logic of ContextDropdown's `multiple` mode (#1163), kept out of the SFC so it
 * can be tested — the frontend has no @vue/test-utils.
 */

/** The selection after a click on a row: toggled, the order of checking kept. */
export function toggleKey(keys: readonly string[], id: string): string[] {
  return keys.includes(id) ? keys.filter(key => key !== id) : [...keys, id];
}
